import wssocket from './socketBase';
let swapsWs = wssocket('',window);
export { swapsWs };


// WEBPACK FOOTER //
// ./src/assets/socket/index.js